import { IDBCache } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_EncounterStorage } from './modules/ModuleFE_EncounterStorage.js';
export class AdvisorRuntimeIDBCache extends IDBCache {
    constructor(dbConfig, dbKey) {
        super(dbConfig, dbKey);
        this.setLastSyncTimestampStorageKey(ModuleFE_EncounterStorage.getStorageKey('last-sync--' + dbKey));
    }
}
//# sourceMappingURL=AdvisorRuntimeIDBCache.js.map